import React from "react";
import PropTypes from "prop-types";
import { Box, Grid2, Typography } from "@mui/material";
import COLORS from "../../../constants/Colors";

const InfoGrid = ({
  title = "Title",
  data = [
    { label: "Title", value: "Value" },
    { label: "Title2", value: "Value" },
    { label: "Title2", value: "Value" },
  ],
  margin = 25,
}) => {
  const DataItem = ({ label, value }) => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
        }}
      >
        <Typography
          fontSize={"14px"}
          fontWeight={700}
          sx={{
            opacity: "0.3",
          }}
        >
          {label}
        </Typography>
        <Typography
          fontSize={"16px"}
          fontWeight={600}
          sx={{
            opacity: value ? "0.8" : "0.3",
            wordBreak: "break-word",
            whiteSpace: "normal",
          }}
        >
          {value || "Not Available"}
        </Typography>
      </Box>
    );
  };
  return (
    <Box
      sx={{
        width: `calc(100% - ${margin * 2}px)`,
        margin: `${margin}px !important`,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Typography
          fontSize={"1rem"}
          fontWeight={600}
          sx={{
            letterSpacing: "2px",
            color: COLORS.PRIMARY,
          }}
        >
          {title.toUpperCase()}
        </Typography>
        <Box
          sx={{
            height: "2px",
            display: "flex",
            flexGrow: 1,
            background: "grey",
            opacity: "0.1",
            marginLeft: "10px",
          }}
        />
      </Box>
      <Grid2
        container
        spacing={2}
        sx={{
          mt: "20px",
        }}
      >
        {data.map((item, index) => (
          <Grid2 item size={6} key={index}>
            <DataItem label={item.label} value={item.value} />
          </Grid2>
        ))}
      </Grid2>
    </Box>
  );
};

InfoGrid.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array,
  margin: PropTypes.number,
};

export default InfoGrid;
